import { Component, OnInit, ViewChild, Input, OnDestroy, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { Subscription } from 'rxjs';
import { DragulaService } from 'ng2-dragula';


//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../services/servicing.service';
import { EmployeeService } from '../../../../services/employee.service';
import { ConfirmationDialogService } from '../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../services/general.service';

//import multiselectdropdown
import { IDropdownSettings } from 'ng-multiselect-dropdown';

//import components
import { EmployeeCreateComponent } from '../employee-create/employee-create.component';
import { SkillsCreateComponent } from '../skills-create/skills-create.component';
import { SkillsAnalysisComponent } from '../skills_analysis-create/skills_analysis-create.component';
import { CommonUtility } from "../../../../utility/commonUtility"
import { fromEvent } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css'],
  encapsulation: ViewEncapsulation.None
})



export class EmployeeListComponent implements OnDestroy, OnInit, AfterViewInit {
  @ViewChild('search') search;
  @ViewChild('reassignedSearch') reassignedSearch;
  getPhotoBase64;
  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;

  //common data
  data: any;


  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableOptions3: any;
  datatableOptions4: any;
  datatableOptions5: any;
  datatableOptions6: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableCols3: any;
  datatableCols4: any;
  datatableCols5: any;
  datatableCols6: any;
  datatableAddCols1: any;
  datatableAddCols4: any;
  datatableAddCols5: any;
  datatableColsDefs3: any;
  datatableColsDefs4: any;
  datatableColsDefs5: any;
  datatableColsDefs6: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  addEmployeeModal: BsModalRef;
  addskillsModal: BsModalRef;
  addMaintenanceModel: BsModalRef;
  skillsAnalysisModel: BsModalRef;
  deleteOption: any;

  lang: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  resign_record: any;
  skills_records: any;
  rolepermission: any;
  array: any;
  groupList: any = [];

  departments: any;
  course_status: any;
  analyses: any;
  course: any;
  course1: any;
  cnt: any;
  skills_value: any;
  skills_value1: any;

  emp_details: any;
  course_details: any;
  certificate: any;
  result: any;
  temp:any;
  reasign_temp: any;
  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');
  subs = new Subscription();

  constructor(
    private servicingService: ServicingService,
    private employeeService: EmployeeService,
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,
    private dragulaService: DragulaService,
    private utility: CommonUtility
  ) { }


  ngOnInit() {
    //fetch data
    this.data = this.route.snapshot.data['sdata'];
    var role = this.ngxRolesService.getRole('servicing');

    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }


    this.getData();
    //tab2 actions
    this.tab2Actions();
    this.tab3Actions();
    this.tab4Actions();
    this.tab5Actions();


    // this.subs.add(this.dragulaService.dropModel("records")
    //   .subscribe(({ sourceModel, targetModel, item }) => {
    //     let arr = [];  let table = [];  
    //     for (let employee of sourceModel) {
    //       arr.push(employee.employeeId)  
    //     }
    //     this.updsorting(arr,table);
    //   })    
    // );

  }

  ngAfterViewInit(){
    const that = this
    setTimeout(function(){
      console.log(this.search)
      fromEvent(this.search, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        // this.updateFilter(value);
        console.log(that.utility)
        console.log(that.datatableCols2)
        console.log(that.records)
        that.records = that.utility.updateFilter(value,that.datatableCols1,that.records,that.temp)
      });  
      
      fromEvent(this.reassignedSearch, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        // this.updateFilter(value);
        console.log(that.utility)
        console.log(that.datatableCols2)
        console.log(that.records)
        that.resign_record = that.utility.updateFilter(value,that.datatableAddCols1,that.resign_record,that.reasign_temp)
      });        
    },3000)
     
  }  


  onItemSelect(item: any) {
    console.log(item.item_id);
  }
  onSelectAll(items: any) {
    console.log(items);
  }


  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  setPageView(type){

  }

  datatableConfig(): void {

    this.datatableColumns();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs1,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.lang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.lang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: this.lang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: this.lang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn1'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig1(): void {

    this.datatableColumns();

    this.datatableOptions2 = {
      dom: 'Bfrtip',
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs2,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.lang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.lang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: this.lang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: this.lang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn2'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';
  }


  datatableConfig3(): void {
    this.datatableColumns3();

    this.datatableOptions3 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs3,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {
        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          let vcnt = $('#table3 th:first-child input').val();

          // console.log(vcnt);

          $('.dmulval').val('');

          for (let i = 1; i <= vcnt; i++) {
            if ($('.chk' + i).is(":checked")) {
              var table3 = new $.fn.dataTable.Api('.satable' + i);

              var count = table3.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table3.rows().deselect();
                selected = false;
              }
              else
                table3.rows().select();

              $('th:first-child input', thead).prop("checked", selected);
              $('.odplus_del' + i).css('display', 'inline-block');
            }
            else {
              var table3 = new $.fn.dataTable.Api('.satable' + i);
              var count = table3.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table3.rows().deselect();
                selected = false;
              }
              $('.odplus_del' + i).css('display', 'none');
            }
          }

          // var table3 = new $.fn.dataTable.Api('.otable1');

          // var count = table3.rows({ selected: true }).count();
          // let selected = true;

          // if (count > 0) {
          //   table3.rows().deselect();
          //   selected = false;
          // }
          // else
          //   table3.rows().select();

          // $('th:first-child input', thead).prop("checked", selected);

        });
      },
      // }
    }

  }


  datatableConfig4(): void {

    this.datatableColumns4();

    this.datatableOptions4 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs4,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table4 = new $.fn.dataTable.Api('#table4');

          var count = table4.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table4.rows().deselect();
            selected = false;
          }
          else
            table4.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table4 = new $.fn.dataTable.Api('#table4');

        table4
          .on('select deselect', function (e, dt, type, indexes) {

            var table2 = new $.fn.dataTable.Api('#table4');
            var selected = table2.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table4, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.lang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.lang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: this.lang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: this.lang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn4'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }

  datatableConfig5(): void {

    this.datatableColumns5();

    this.datatableOptions5 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table5 = new $.fn.dataTable.Api('#table5');

          var count = table5.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table5.rows().deselect();
            selected = false;
          }
          else
            table5.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table5 = new $.fn.dataTable.Api('#table5');

        table5
          .on('select deselect', function (e, dt, type, indexes) {

            var table2 = new $.fn.dataTable.Api('#table5');
            var selected = table2.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table5, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.lang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.lang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: this.lang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: this.lang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table5');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn5'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }

  datatableConfig6(): void {
    this.datatableColumns6();

    this.datatableOptions6 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs6,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {
        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          // let vcnt = $('th:first-child input').val();

          var vcnt = $('.csvchk').val();

          $('.csmulval').val('');

          for (let i = 1; i <= vcnt; i++) {
            
            if ($('.cschk' + i).is(":checked")) {

              var table5 = new $.fn.dataTable.Api('.cstable' + i);

              var count = table5.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table5.rows().deselect();
                selected = false;
              }
              else
              table5.rows().select();

              $('th:first-child input', thead).prop("checked", selected);
              $('.csplus_del' + i).css('display', 'inline-block');
            }
            else {
              var table5 = new $.fn.dataTable.Api('.cstable' + i);
              var count = table5.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table5.rows().deselect();
                selected = false;
              }
              $('.csplus_del' + i).css('display', 'none');
            }
          }

          // var table3 = new $.fn.dataTable.Api('.otable1');

          // var count = table3.rows({ selected: true }).count();
          // let selected = true;

          // if (count > 0) {
          //   table3.rows().deselect();
          //   selected = false;
          // }
          // else
          //   table3.rows().select();

          // $('th:first-child input', thead).prop("checked", selected);

        });
      },
      // }
    }

  }


  sadatatableExport(val) {

    $('.scol_val').val(val);
    $('#sadatatableExport3').modal('show');
    // $('#datatableExportBtn3').show();
    $('#datatableExportBtn3').html('');
    let j = val;

    // console.log(val);

    if (j != "") {

      var table3 = new $.fn.dataTable.Api('.satable' + j);

      // console.log(table3);


      var buttons3 = new $.fn.dataTable.Buttons(table3, {
        dom: {
          button: {
            className: ''
          }
        },
        buttons: [
          {
            extend: 'csv',
            text: 'Export CSV',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.satable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();
                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'pdfHtml5',
            text: 'Export PDF',
            className: 'btn btn-info',
            orientation: 'landscape',
            pageSize: 'A3',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.satable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;


                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'excel',
            text: 'Export Excel',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.satable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'print',
            text: 'Print',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.satable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
        ], select: true
      }).container().appendTo($('#datatableExportBtn3'));
    }

    $('.scol_val').val('');


  }

  close() {
    $('#sadatatableExport3').modal('hide');
    // $('#datatableExportBtn3').detach();
    $('#sadatatableExport3').clear();
  }

  onchk(i, j) {
    // console.log($('#'+i).hasClass('selected'));

    $('.dmulval').val('');
    if ($('#' + i).hasClass('selected') == false) {
      $('.sadplus_del' + j).css('display', 'inline-block');
      $('.dmulval').val(i);
    }
    else {
      $('.sadplus_del' + j).css('display', 'none');
      $('.dmulval').val('');
    }

  }


  csdatatableExport(val) {

    $('.scol_val').val(val);
    $('#csdatatableExport6').modal('show');
    // $('#datatableExportBtn3').show();
    $('#datatableExportBtn6').html('');
    let j = val;

    // console.log(val);

    if (j != "") {

      var table5 = new $.fn.dataTable.Api('.cstable' + j);

      // console.log(table5);


      var buttons5 = new $.fn.dataTable.Buttons(table5, {
        dom: {
          button: {
            className: ''
          }
        },
        buttons: [
          {
            extend: 'csv',
            text: 'Export CSV',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.cstable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();
                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'pdfHtml5',
            text: 'Export PDF',
            className: 'btn btn-info',
            orientation: 'landscape',
            pageSize: 'A3',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.cstable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;


                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'excel',
            text: 'Export Excel',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.cstable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
          {
            extend: 'print',
            text: 'Print',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.cstable1');
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCloud"
          },
        ], select: true
      }).container().appendTo($('#datatableExportBtn6'));
    }

    $('.cscol_val').val('');


  }

  closecs() {
    $('#csdatatableExport6').modal('hide');
    // $('#datatableExportBtn3').detach();
    $('#csdatatableExport6').clear();
  }

  csonchk(i, j) {
    // console.log($('#'+i).hasClass('selected'));

    $('.csdmulval').val('');
    if ($('#' + i).hasClass('selected') == false) {
      $('.csdplus_del' + j).css('display', 'inline-block');
      $('.csdmulval').val(i);
    }
    else {
      $('.csdplus_del' + j).css('display', 'none');
      $('.csdmulval').val('');
    }

  }
  

  datatableColumns(): void {

    this.datatableColsDefs1 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
      {
        targets: 12,
        visible: false,
        orderable: false,
      },
    ];

    this.datatableCols1 = [
      { id: 2, value: this.lang.sno, isSelected: false },
      { id: 3, value: this.lang.name, isSelected: false },
      { id: 4, value: this.lang.surname, isSelected: false },
      { id: 5, value: this.lang.age, isSelected: false },
      { id: 6, value: this.lang.email, isSelected: false },
      { id: 7, value: this.lang.phone, isSelected: false },
      { id: 8, value: this.lang.task, isSelected: false },
      { id: 9, value: this.lang.qualifications, isSelected: false },
      { id: 10, value: this.lang.assumptionData, isSelected: false },
      { id: 11, value: this.lang.status, isSelected: false },
    ];

    this.datatableAddCols1 = [
      { id: 12, value: this.lang.taxCode, isSelected: false },
      { id: 13, value: this.lang.dateofBirth, isSelected: false },
      { id: 14, value: this.lang.placeofBirth, isSelected: false },
      { id: 15, value: this.lang.address, isSelected: false },
      { id: 16, value: this.lang.titleofStudy, isSelected: false },
      { id: 17, value: this.lang.hourlyCost, isSelected: false },
    ];

  }

  datatableColumns1(): void {
    this.datatableColsDefs2 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols2 = [
      { id: 2, value: 'No', isSelected: false },
      { id: 3, value: 'Skill Code', isSelected: false },
      { id: 4, value: 'Description', isSelected: false },
      { id: 5, value: 'Repetition', isSelected: false },
      { id: 6, value: 'Notification', isSelected: false },
      { id: 7, value: 'Level Of Competence Required', isSelected: false },
      { id: 8, value: 'Employee To Which Skill Applies', isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  datatableColumns3(): void {
    this.datatableColsDefs3 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols3 = [
      { id: 2, value: 'No', isSelected: false },
      { id: 3, value: 'Skill Code', isSelected: false },
      { id: 4, value: 'Description', isSelected: false },
      { id: 5, value: 'Repetition', isSelected: false },
      { id: 6, value: 'Notification', isSelected: false },
      { id: 7, value: 'Level Of Competence Required', isSelected: false },
      { id: 8, value: 'Employee To Which Skill Applies', isSelected: false },
    ];

    // this.datatableAddCols1 = [
    // { id: 2, value: 'Attachments', isSelected: false },
    // ];

  }

  datatableColumns4(): void {
    this.datatableColsDefs4 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols4 = [
      { id: 2, value: 'No', isSelected: false },
      { id: 3, value: 'Course Code', isSelected: false },
      { id: 4, value: 'Title', isSelected: false },
      { id: 5, value: 'Course Type', isSelected: false },
      { id: 6, value: 'Duration ( hours )', isSelected: false },
      { id: 7, value: 'Part.', isSelected: false },
      { id: 8, value: 'Name Of The Participents', isSelected: false },
      { id: 9, value: 'Place', isSelected: false },
      { id: 10, value: 'Start Date', isSelected: false },
      { id: 11, value: 'End Date', isSelected: false },
      { id: 12, value: 'Applicable Skills', isSelected: false },
      { id: 13, value: 'Teacher', isSelected: false },
      { id: 14, value: 'Status', isSelected: false },
    ];

    this.datatableAddCols4 = [
      { id: 15, value: 'Validity type', isSelected: false },
    ];

  }


  datatableColumns5(): void {
    this.datatableCols5 = [
      { id: 0, value: 'No', isSelected: false },
      { id: 1, value: 'Employee Name', isSelected: false },
      { id: 2, value: 'Employee Surname', isSelected: false },
      { id: 3, value: 'Tax Code', isSelected: false },
      { id: 4, value: 'Email', isSelected: false },
      { id: 5, value: 'Course Code', isSelected: false },
      { id: 6, value: 'Course attended', isSelected: false },
      { id: 7, value: 'Duration ( hours )', isSelected: false },
      { id: 8, value: 'Start Date', isSelected: false },
      { id: 9, value: 'End Date', isSelected: false },
      { id: 10, value: 'Certificate', isSelected: false },
    ];
  }

  datatableColumns6(): void {
    this.datatableColsDefs6 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols6 = [
      { id: 2, value: 'No', isSelected: false },
      { id: 3, value: 'Course Code', isSelected: false },
      { id: 4, value: 'Title', isSelected: false },
      { id: 5, value: 'Course Type', isSelected: false },
      { id: 6, value: 'Duration ( hours )', isSelected: false },
      { id: 7, value: 'Part.', isSelected: false },
      { id: 8, value: 'Place', isSelected: false },
      { id: 9, value: 'Duration ( hours )', isSelected: false },
      { id: 10, value: 'Start Date', isSelected: false },
      { id: 11, value: 'End Date', isSelected: false },
      { id: 12, value: 'Teacher', isSelected: false },
    ];
  }



  datatableFilter(): void {

    // $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
    //   const filt1 = data[4] || '';
    //   const filt2 = data[10] || '';
    //   const filt3 = data[11] || '';
    //   const filt4 = data[14] || '';

    //   let a = this.filter1;
    //   let aa = this.filter2;
    //   let aaa = this.filter3;
    //   let aaaa = this.filter4;

    //   var status1 = false;
    //   var status2 = false;
    //   var status3 = false;
    //   var status4 = false;

    //   if (Object.keys(a).length == 0)
    //     status1 = true;
    //   else {
    //     Object.keys(a).forEach(function (key) {
    //       if (a[key].item_id && filt1 == a[key].item_id)
    //         status1 = true;
    //     });
    //   }

    //   if (Object.keys(aa).length == 0)
    //     status2 = true;
    //   else {
    //     Object.keys(aa).forEach(function (key) {
    //       if (aa[key].item_id && filt2 == aa[key].item_id)
    //         status2 = true;
    //     });
    //   }

    //   if (Object.keys(aaa).length == 0)
    //     status3 = true;
    //   else {
    //     Object.keys(aaa).forEach(function (key) {
    //       if (aaa[key].item_id && filt3 == aaa[key].item_id)
    //         status3 = true;
    //     });
    //   }

    //   if (Object.keys(aaaa).length == 0)
    //     status4 = true;
    //   else {
    //     Object.keys(aaaa).forEach(function (key) {
    //       if (aaaa[key].item_id && filt4 == aaaa[key].item_id)
    //         status4 = true;
    //     });
    //   }

    //   if (status1 && status2 && status3 && status4)
    //     return true;
    //   else
    //     return false;


    // });



    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      // console.log(data[17]);
      const filt2 = data[17] || '';
      var status = true;

      if (this.filter2 && filt2 != this.filter2)
        status = false;

      return status;
    });

  }

  datatableFilterAction(): void {
    // console.log(DataTables.Api);
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.draw();

      // dtInstance.columns().every(function () {});


    });
  }

  getData() {

    this.employeeService.getList()
      .subscribe(
        (res) => {
          this.lang = this.employeeService.listLang(res);
          this.records = this.temp = res.data.all_record;
          this.resign_record  = this.reasign_temp = res.data.resign_record;
          

          //load datatable
          this.datatableConfig();
          this.datatableFilter();

        }
      );

  }


  tab2Actions(): void {

    this.employeeService.getList()
      .subscribe(
        (res) => {
          this.lang = this.employeeService.listLang(res);
          this.skills_records = res.data.skills_records;
          // console.log(this.skills_records);

          //load datatable
          this.datatableConfig1();
          this.datatableFilter();

        }
      );

  }

  tab3Actions(): void {

    this.employeeService.getSkillsList()
      .subscribe(
        (res) => {
          this.lang = this.employeeService.listLang(res);
          this.departments = res.data.departments;
          this.analyses = res.data.analyses;
          this.cnt = this.analyses.length;

          // console.log(this.skills_records);

          //load datatable
          this.datatableConfig3();

          // this.datatableFilter();

        }
      );

  }

  tab4Actions(): void {

    this.employeeService.getList()
      .subscribe(
        (res) => {
          this.lang = this.employeeService.listLang(res);
          this.course1 = res.data.course;

          //load datatable
          this.datatableConfig4();

        }
      );


  }

  tab5Actions(): void {

    this.employeeService.getList()
      .subscribe(
        (res) => {
          this.lang = this.employeeService.listLang(res);
          this.skills_value = res.data.skills_value;
          this.skills_value1 = res.data.skills_value;
          this.cnt = this.skills_value.length;
          // console.log(this.skills_value);
          //load datatable
          this.datatableConfig6();

        }
      );
  }


  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.EMPLOYEE_LIST]);
      });
  }

  success(msg: any) {
    this.generalService.notify_msg('success', msg);
    this.redirect();
  }


  mulitSelect() {
    this.dropdownList = [
      { item_id: this.lang.vehicle, item_text: this.lang.vehicle },
      { item_id: this.lang.plant, item_text: this.lang.plant },
      { item_id: this.lang.machine, item_text: this.lang.machine },
      { item_id: this.lang.fireDispenser, item_text: this.lang.fireDispenser },
      { item_id: this.lang.firstServiceDevice, item_text: this.lang.firstServiceDevice },
      { item_id: this.lang.individualProtectionDevice, item_text: this.lang.individualProtectionDevice },
      { item_id: this.lang.safetyEquipment, item_text: this.lang.safetyEquipment }
    ];


    let that = this;

    let loca = this.lang.locations;
    Object.keys(loca).forEach(function (key) {
      // console.log(loca[key]);   
      that.dropdownList1.push({ item_id: loca[key], item_text: loca[key] },)
    });


    let loca1 = this.lang.responsibles;
    Object.keys(loca1).forEach(function (key) {
      // console.log(loca1[key]);   
      that.dropdownList2.push({ item_id: loca1[key], item_text: loca1[key].replace(/&nbsp;/g, ' ') },)
    });


    this.dropdownList3 = [
      { item_id: '1', item_text: 'active' },
      { item_id: '2', item_text: 'sss' },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };


  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }

    for (var i = 0; i < this.datatableAddCols1.length; i++)
      this.datatableAddCols1[i].isSelected = selected;


    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    for (var i = 0; i < this.datatableAddCols1.length; i++) {
      if (this.datatableAddCols1[i].id == id)
        this.datatableAddCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

    for (var i = 0; i < this.datatableAddCols1.length; i++) {
      if (this.datatableAddCols1[i].isSelected)
        table1.column(parseInt(this.datatableAddCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableAddCols1[i].id)).deselect();
    }

  }

  export2_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      this.datatableCols2[i].isSelected = selected;
    }
    this.datatable_export2_choose_column();

  }

  export2_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].id == id)
        this.datatableCols2[i].isSelected = selected;
    }

    this.datatable_export2_choose_column();

  }

  datatable_export2_choose_column(): void {

    var table1_name = '#table2';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].isSelected)
        table1.column(parseInt(this.datatableCols2[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols2[i].id)).deselect();
    }

  }



  export3_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      this.datatableCols3[i].isSelected = selected;
    }
    this.datatable_export3_choose_column();

  }

  export3_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      if (this.datatableCols3[i].id == id)
        this.datatableCols3[i].isSelected = selected;
    }

    this.datatable_export3_choose_column();

  }

  datatable_export3_choose_column(): void {

    let vcnt = $('th:first-child input').val();
    for (let j = 1; j <= vcnt; j++) {

      var table1_name = '.satable' + j;
      var table1 = new $.fn.dataTable.Api(table1_name);

      for (var i = 0; i < this.datatableCols3.length; i++) {
        if (this.datatableCols3[i].isSelected)
          table1.column(parseInt(this.datatableCols3[i].id)).select();
        else
          table1.column(parseInt(this.datatableCols3[i].id)).deselect();
      }
    }

  }



  export4_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      this.datatableCols4[i].isSelected = selected;
    }
    this.datatable_export4_choose_column();

  }

  export4_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].id == id)
        this.datatableCols4[i].isSelected = selected;
    }

    this.datatable_export4_choose_column();

  }

  datatable_export4_choose_column(): void {

    var table1_name = '#table4';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].isSelected)
        table1.column(parseInt(this.datatableCols4[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols4[i].id)).deselect();
    }

  }

  export5_select_deselect_all(event): void {
    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols5.length; i++) {
      this.datatableCols5[i].isSelected = selected;
    }
    this.datatable_export5_choose_column();

  }

  export5_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols5.length; i++) {
      if (this.datatableCols5[i].id == id)
        this.datatableCols5[i].isSelected = selected;
    }

    this.datatable_export5_choose_column();

  }

  datatable_export5_choose_column(): void {

    var table1_name = '#table5';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols5.length; i++) {
      if (this.datatableCols5[i].isSelected)
        table1.column(parseInt(this.datatableCols5[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols5[i].id)).deselect();
    }

  }

  export6_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols6.length; i++) {
      this.datatableCols6[i].isSelected = selected;
    }
    this.datatable_export6_choose_column();

  }

  export6_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols6.length; i++) {
      if (this.datatableCols6[i].id == id)
        this.datatableCols6[i].isSelected = selected;
    }

    this.datatable_export6_choose_column();

  }

  datatable_export6_choose_column(): void {

    // let vcnt = $('th:first-child input').val();
    let vcnt = $('.csvchk').val();
    console.log(vcnt);
    for (let j = 1; j <= vcnt; j++) {

      var table1_name = '.cstable' + j;
      var table1 = new $.fn.dataTable.Api(table1_name);

      for (var i = 0; i < this.datatableCols6.length; i++) {
        if (this.datatableCols6[i].isSelected)
          table1.column(parseInt(this.datatableCols6[i].id)).select();
        else
          table1.column(parseInt(this.datatableCols6[i].id)).deselect();
      }
    }

  }
  


  // addServicing() {

  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // }
  // setPageView(view) {
  //   this.pageView = view;
  // }

  // addMaintenance(OID, SID, SPID) {
  //   this.addMaintenanceModel = this.modalService.show(ServicingMaintenance, { class: 'modal-lgs', initialState: { 'ID': OID, 'SID': SID, 'PID': SPID, 'action': 'modify', 'langs': this.lang } });
  // }

  // editServicing(ID) {
  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang } });
  // }

  addskills() {
    this.addskillsModal = this.modalService.show(SkillsCreateComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });

  }

  editSkills(ID) {
    this.addskillsModal = this.modalService.show(SkillsCreateComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang } });
  }

  addEmployee() {
    this.addEmployeeModal = this.modalService.show(EmployeeCreateComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });

  }

  editEmployee(ID) {
    this.addEmployeeModal = this.modalService.show(EmployeeCreateComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'langs': this.lang } });
  }




  delete(ID) {

    this.confirmationDialogService.confirm('Employee Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.delete(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }

  deleteMultiOrdinary(ID) {

    this.confirmationDialogService.confirm('Employee Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.delete(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }

  deleteSkills(ID) {

    this.confirmationDialogService.confirm('Employee Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.deleteSkills(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }

  coursedelete(ID) {

    this.confirmationDialogService.confirm('Employee Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.deleteCourses(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.multiDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }

  multiSkillsDelete() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete all selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.multiSkillsDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }

  multiCoursesDelete() {

    var table1 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete all selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.multiCoursesDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }



  multiDelete1() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.multiDelete1(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }

  multiDuplicate() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to duplicate the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.multiDuplicate(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });

  }

  multiSkillsDuplicate() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();
    this.employeeService.multiSkillsDuplicate(selectedRows)
      .subscribe(
        (res) => {
          if (res.status)
            this.success(res.msg);
          else
            this.error(res.msg);
        });


  }

  multiCoursesDuplicate() {
    var table4 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table4.rows({ selected: true }).ids().toArray();

    this.employeeService.multiCoursesDuplicate(selectedRows)
      .subscribe(
        (res) => {
          if (res.status)
            this.success(res.msg);
          else
            this.error(res.msg);
        });
  }

  duplicate(ID) {

    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure you duplicate this line?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.duplicate(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });


  }




  onPhotoPickerChange(ev) {
    let file = ev.target.files[0];
    file = ev.target.files[0];

    // console.log(file.name);
    let file_name = file.name;
    if (!(/\.(csv)$/i).test(file_name)) {
      alert('Please upload valid excel file_name .csv only.');
      $('#file').val('');
    }
    else {
      let fs = new FileReader();
      fs.onload = (res: any) => {
        this.getPhotoBase64 = res.target.result;
        $('#profile_input').val('');
      };
      fs.readAsDataURL(file);
    }
  }

  onclick() {
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    if (profileImage != undefined && $('#file').val() != '') {
      this.employeeService.updateImport(profileImage)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#datatableExport2").modal("hide");

            }
            else {
              this.error(res.msg);
              $("#datatableExport2").modal("hide");

            }
          });
    }
  }

  onclick2() {
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    // console.log($('#file').val());


    if (profileImage != undefined && $('.file').val() != '') {
      this.employeeService.updateImportSkills(profileImage)
        .subscribe(
          (res) => {
            if (res.status) {
              this.success(res.msg);
              $("#datatableImport2").modal("hide");

            }
            else {
              this.error(res.msg);
              $("#datatableImport2").modal("hide");

            }
          });
    }
  }

  updsorting(data: any, table: any) {
    this.employeeService.sorting(data, table)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);

          }
          else {
            this.error(res.msg);

          }
        });
  }

  // chkEmpty(value: String): String {
  //   return value.replace(' ', '&nbsp;');
  //   }

  add_skills_analysis(SID, PID) {
    // console.log(PID);
    this.skillsAnalysisModel = this.modalService.show(SkillsAnalysisComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'PID': PID, 'langs': this.lang } });
  }

  onSelect() {

    // console.log($('#course_name').val()); return false;

    let course_name = $('#course_name').val()

    this.employeeService.searchCourse(course_name).subscribe(
      res => {
        $("#search_courses").css("display", "block");
        this.result = res.data.result;

        //load datatable
        this.datatableConfig5();

      }
    );

  }



  hired(ID) {

    this.confirmationDialogService.confirm('Employee Hire', 'Do you want to hire this employee?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.hired(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }




  resign(ID) {

    this.confirmationDialogService.confirm('Employee Resigned', 'Do you want to resign this employee?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.employeeService.resign(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }



}
